import { render } from "./LResourceCard.vue?vue&type=template&id=379f88c6"
import script from "./LResourceCard.vue?vue&type=script&lang=js"
export * from "./LResourceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__